module.exports = __webpack_public_path__ + "static/media/EditPenIcon.045ce1dd.svg";